<template>
    <!--报警类型-->
    <div class="common-space-between">
       <NavBlock   ref="navBlock"></NavBlock>
       <TableBlock ref="tableData" :columns="columns" :action="action" :ispage="false" :showBtn="true" :param="param" :navHeight="220">
            <div class="common-space-between">
               <div class="common-space-around">
                   <el-input v-model="param.policeTypeName" :size="this.$store.state.inputSize" placeholder="请输入模块名称"  style="margin-right:10px;width:200px"/>
                   <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="topSearchBtn">搜索</el-button>
                   <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
               </div>
               <el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
           </div>
        </TableBlock>
        <addEType ref="addEType"></addEType>
  </div>
</template>
<script>
 import NavBlock from './common-module/navBtn-block.vue'
 import TableBlock from '@/components/component-Table/block-table.vue'
 import addEType from './common-module/add-type-alarm.vue'
 import {columns} from './columns/alarmtype';
 import {operate} from '@/utils/config'
 import {putFun} from '@/utils/httpFun';
export default {
  name: 'index',
  components:{
      NavBlock:NavBlock,
      TableBlock:TableBlock,
      addEType:addEType
  },
  data:()=>({  
      mark:0,
      action:operate.BAOJINGTYPELIST,
      columns:[],    //表头
      param:{        //请求参数
         dtId:'123',
         policeTypeName:null
      },     
  }),
  created(){
    this.columns = columns(this);
  },
  // mounted
  methods:{
    
    topSearchBtn(){
       this.searchBtn({id:this.param.dtId}) 
    },

    //搜索
    searchBtn(ev){
       this.param.dtId = ev.id
       this.$nextTick(res=>{
          this.$refs.tableData.getDatas()
       })
    }, 

    //充值第一页
    resetBtn(){
      this.param.policeTypeName = null
      this.$nextTick(res=>{
          this.$refs.tableData.resetHttp()
      })
    },

    //新增模版
    addBtn(){
       let parms = {
           mark:"add",
           dtId:this.param.dtId
       }
       this.$refs.addEType.openBtn(parms)
    },
    //编辑
    eidtBtn(ev){
       ev.mark = 'eidt'
       this.$refs.addEType.openBtn(ev)
    },
    //删除
    deleteBtn(ev){
      
      this.$confirm('确认要删除['+ev.policeTypeName+"]?", '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass:"popDeleteW",
        }).then(() => {
            putFun(operate.BAOJINGTYPEDELETE+"?id="+ev.id,{},res=>{
                if(res.data){
                  this.$refs.tableData.getDatas() 
                }
            })
        }).catch(() => {

        }); 
      }
  }
}
</script>
<style lang="scss" scoped>
   
</style>
